import { useCurrentEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { Typography } from '@optimus-web/core';
import { Dash, DefaultErrorHandler, LocalizedTextTag } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { LocalizedProperty } from '@mews/framework';
import { ModalSidePanel } from '../../../../components/commander-ui';
import { useGetRateDetail } from '../../queries';
import { RateSidePanelContent } from './RateSidePanelContent';
import { RateSidePanelActions } from './SidePanelActions';

interface RateSidePanelProps {
    rateId?: string;
    closeSidePanel: () => void;
}

export const RateSidePanel = ({ rateId, closeSidePanel }: RateSidePanelProps) => {
    const { data, isFetching, isError } = useGetRateDetail(rateId);

    const { defaultLanguageCode } = useCurrentEnterprise();

    const title = (
        <Typography textStyle="titleMediumStrong" as="div">
            {data ? <LocalizedProperty property={data.names} /> : <Dash />}
        </Typography>
    );

    const tag = data?.isEnabled ? (
        <LocalizedTextTag textKey={TextKey.Activated} variant="success" />
    ) : (
        <LocalizedTextTag textKey={TextKey.Deactivated} variant="danger" />
    );

    const content = data ? (
        <RateSidePanelContent
            names={data.names}
            shortNames={data.shortNames}
            externalNames={data.externalNames}
            descriptions={data.descriptions}
            serviceName={data.serviceName}
            baseRateName={data.baseRateName}
            isDefault={data.isDefault}
            type={data.type}
            rateGroupName={data.rateGroupName}
            accountingCategoryName={data.accountingCategoryName}
            businessSegmentName={data.businessSegmentName}
            defaultReservationPurpose={data.defaultReservationPurpose}
            pricingClassification={data.pricingClassification}
            rateKey={data.rateKey}
            ordering={data.ordering}
            creatorProfile={data.creatorProfile}
            createdUtc={data.createdUtc}
            updaterProfile={data.updaterProfile}
            updatedUtc={data.updatedUtc}
        />
    ) : null;

    const headerActions =
        rateId && data ? (
            <RateSidePanelActions
                rateId={rateId}
                rateName={data.names[defaultLanguageCode]}
                isEnabled={data.isEnabled}
                closeSidePanel={closeSidePanel}
            />
        ) : null;

    return (
        <ModalSidePanel
            opened={!!rateId}
            loading={isFetching}
            title={title}
            tag={tag}
            onClose={closeSidePanel}
            content={isError ? <DefaultErrorHandler /> : content}
            width="medium"
            headerActions={headerActions}
        />
    );
};
